import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import AccountDetails from "../../../components/AccountMetrics/AccountDetails";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import "./style.scss";

function AccountInfo() {
  const accountsData = useSelector((state) => state.account.accountMetrics);
  const [errorModalOpen, setErrorModalOpen] = useState(accountsData.error);

  useEffect(() => {
    setErrorModalOpen(accountsData.error);
  }, [accountsData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="accountinfo-container">
      {errorModalOpen && (
        <ErrorModal
          desc={accountsData.message}
          setModalOpen={setErrorModalOpen}
          btnText="Cancel"
        />
      )}

      {!accountsData.loading && !accountsData.error && (
        <div className="accountinfo-subcontainer">
          <AccountDetails />
        </div>
      )}
    </div>
  );
}

export default AccountInfo;
